import { bookingGroup } from '@cnt-admin/data-access';
import { IReservation } from '@curbnturf/entities';
import { DateTime } from 'luxon';

/** How many of a person's bookings the search box lists under them. */
export const UPCOMING_SHOWN = 3;

export interface UpcomingBooking {
  reservation: IReservation;
  /** Their side of it. */
  role: 'guest' | 'host';
}

const isoDay = (v: unknown) => (v ? String(v).slice(0, 10) : undefined);

/**
 * A person's booked or requested stays that haven't ended, soonest first
 * (a host booking their own listing counts once, as the host).
 */
export function upcomingBookings(
  asGuest: IReservation[],
  asHost: IReservation[],
  now: DateTime = DateTime.now(),
  limit = UPCOMING_SHOWN,
): UpcomingBooking[] {
  const today = now.toISODate() as string;
  const hostIds = new Set(asHost.map((r) => r.id));
  const all: UpcomingBooking[] = [
    ...asHost.map((reservation) => ({ reservation, role: 'host' as const })),
    ...asGuest.filter((r) => !hostIds.has(r.id)).map((reservation) => ({ reservation, role: 'guest' as const })),
  ];
  return all
    .filter(({ reservation: r }) => {
      const group = bookingGroup(r);
      const end = isoDay(r.date?.to) ?? isoDay(r.date?.from);
      return (group === 'booked' || group === 'pending') && !!end && end >= today;
    })
    .sort(
      (a, b) =>
        (isoDay(a.reservation.date?.from) ?? '').localeCompare(isoDay(b.reservation.date?.from) ?? '') ||
        (a.reservation.id ?? 0) - (b.reservation.id ?? 0),
    )
    .slice(0, limit);
}
